<script type="text/javascript">
	import { get, writable } from "svelte/store";
	import { onMount } from "svelte";
	import Textfield, { Input, Textarea } from "@smui/textfield";

	import TabBar from '@smui/tab-bar';
	import Tab, { Icon, Label as TabLabel } from '@smui/tab';

	import "./HydrographicCharts.scss";
	import TextfieldWithButton from "../../UI/TextfieldWithButton/TextfieldWithButton.svelte";
	import Button, {Label} from '@smui/button';
	import SpinnerButton from "../../UI/Admin/SpinnerButton.svelte";

	import LoadState from "../../Enums/LoadState";
	import MapStore from "../../Map/Store";
	import ModalWindow from "../../UI/ModalWindow.svelte";

	import User from "../../Branding/User";
	import Feature from "../../Branding/Feature";

	import HydrographicChartStore from "./Store";
	import NauticalChartsTable from "./NauticalChartsTable.svelte";
import LngLatFormat from "../../Enums/LngLatFormat";
import StringHelper from "../../Helpers/StringHelper";
import AuthStore from "../../Auth/Store";

	let loadState = HydrographicChartStore.meta.loadState;
	let loaded = false;
	$: {
		loaded = $loadState === LoadState.LOADED;
	}

	let visible = HydrographicChartStore.meta.visible;
	HydrographicChartStore.meta.visible.subscribe((visible) => {
		if (visible) {
			HydrographicChartStore.actions.init();
		}
	});

	let lastUpdated = HydrographicChartStore.meta.lastUpdated;
	$: {
		$visible;
		$lastUpdated;
		HydrographicChartStore.actions.updateBoundsFeatureCollection();
		HydrographicChartStore.actions.updateVisibility();
	}

	let charts = HydrographicChartStore.results.charts;

	let spatialQueryCharts = HydrographicChartStore.spatialQuery.results.charts;
	let spatialQueryLoadState = HydrographicChartStore.spatialQuery.meta.loadState;
	let spatialQueryError = HydrographicChartStore.spatialQuery.meta.error;

	$: {
		$lastUpdated;
		$charts = $charts;
		$spatialQueryCharts = $spatialQueryCharts;
	}

	let rawFilterString = HydrographicChartStore.filters.filterString;

	let hstyle = "font-weight:bold;margin-top:5px;margin-bottom:5px;";

	let tabs = ["List", "Query"];
	let activeTab = writable("List");

	let user = AuthStore.session.user;
	let lngLatReadable = writable($user.defaultLngLatStr);

</script>

<ModalWindow
	title={`Nautical Charts (Beta)`}
	hasCloseButton={true}
	hasBackground={false}
	resizable={true}
	draggable={true}
	fullscreen={false}
	padding={false}
	position="top-right"
	height="70%"
	bind:open={$visible} >

	<!-- <button on:click={() => {
		MapStore.helpers.printLayers();
	}}>Test</button> -->

		<TabBar tabs={tabs} let:tab bind:active={$activeTab} class="border-shadow">
			<Tab tab={tab} minWidth><TabLabel>{tab}</TabLabel></Tab>
		</TabBar>

		<div class="content padding">

			{#if $activeTab === "List"}

				<Textfield fullwidth dense variant="filled" label="Filter charts by name..."
					bind:value={$rawFilterString}
					/>

				<NauticalChartsTable
					charts={$charts}
					filterString={$rawFilterString}
					on:update={()=>{ $lastUpdated = Date.now(); }}
					/>

			{:else if $activeTab === "Query"}

				<h2>Point (lng, lat):</h2>
				<TextfieldWithButton
					bind:value={$lngLatReadable}
					disabled={false}
					buttonIcon="colorize"
					on:change={()=>{

					}}
					on:keyup={(e) => {

					}}
					on:buttonclick={(e) => {
						MapStore.helpers.startSingleLngLatPick((resultText)=>{
							$lngLatReadable = resultText;
						});
					}}
					/>
				{#if $spatialQueryLoadState === LoadState.LOADING}
					<SpinnerButton style="width:100%;margin-top:10px;"/>
				{:else}
					<Button color="secondary" variant="unelevated"
						style="width:100%;margin-top:10px;"
						on:click={()=>{
							let useLngLat = $lngLatReadable;
							if ($user.lngLatFormat === LngLatFormat.DMS) {
								useLngLat = StringHelper.formatDMSToDecimal($lngLatReadable);
							}
							const arr = useLngLat.split(", ");
							HydrographicChartStore.actions.spatialQuery(arr);
						}}>
						<Label>Submit</Label>
					</Button>
				{/if}

				{#if $spatialQueryLoadState === LoadState.LOADED}
					{#if $spatialQueryCharts.length === 0}
						<div class='msgbox bg-info mt-10'>No results.</div>
					{:else}
						<NauticalChartsTable
							charts={$spatialQueryCharts}
							height="200"
							on:update={()=>{ $lastUpdated = Date.now(); }}
						/>
					{/if}
				{/if}
				{#if $spatialQueryError.length > 0}
					<div class='msgbox bg-error mt-10'>{$spatialQueryError}</div>
				{/if}

			{/if}
			<p class='nauticalcharts-data-attribution mt-10 mb-0'>This data is provided by the <a href='https://www.gov.uk/government/organisations/uk-hydrographic-office' target='new'>UK Hydrographic Office</a> (UKHO).</p>
		</div>

</ModalWindow>

